import { mutations } from "@/graphql";
import { useState } from "react";
import { useMutation } from "@apollo/client/react";
export const useUpdateModule = (
  onCompleted: (data?: any) => void = () => {},
  onError: (error?: any) => void = () => {},
) => {
  const [success, setSuccess] = useState(false);
  const [resetForm, setResetForm] = useState(false);

  const [updateModule, { loading, data }] = useMutation<any>(
    mutations.updateModule,
    {
      onCompleted: (response) => {
        if (
          response.updateModule?.success ||
          response.comUpdateModule?.success
        ) {
          setSuccess(true);
          setResetForm(true);
          setTimeout(() => {
            setSuccess(false);
            setResetForm(false);
          }, 5000);
          onCompleted();
        } else {
          setSuccess(false);
        }
      },
      onError: ({ message }) => {
        setSuccess(false);
        onError(message);
      },
    },
  );
  return {
    updateModule: updateModule,
    loading,
    success,
    data,
    resetForm,
  };
};
